import consumer from "./consumer"

const initChatCable = (consultationId) => {
  const chatChannel = consumer.subscriptions.create(
    { channel: "ChatChannel", consultation_id: consultationId },
    {
      received(data) {
        // Додаємо нове повідомлення в DOM
        const messagesContainer = document.getElementById("messages");
        messagesContainer.innerHTML += data.message;
      },

      sendMessage(message) {
        this.perform("send_message", { message: message });
      }
    }
  );

  return chatChannel;
};

export { initChatCable }
